import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Content Slider
 */
class ContentSlider extends HtmlElement {
	onReady() {
		this.init();
		this.toggleNavInside();
	}

	onResize() {
		this.toggleNavInside();
	}

	init() {
		var _self = this;

		this.$element.each(function() {
			var data = $(this).data();
			var opts = {
				navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
				margin: 30,
				items: 1,
				responsive: {
					600: {
						items: 2
					},
					1000: {
						items: $(this).data('owl-items')
					}
				}
			};

			for(var prop in data) {
				if(prop.substring(0, 3) === 'owl') {
					var p = prop.replace('owl', '');
					p = _self.firstToLowerCase(p);

					if(!(p in opts)) {
						opts[p] = data[prop];
					}
				}
			}

			$(this).owlCarousel(opts);
		});
	}

	toggleNavInside() {
		var winW = $window.width();

		this.$element.each(function() {
			if($(this).data('nav-inside') == 0) {
				var $row = $(this).closest('.row'),
					rowMaxW = parseInt($row.css('max-width')),
					arrowLeftMinus = 32,
					arrowRightMinus = 32,
					rowMaxWArrows = rowMaxW + arrowLeftMinus + arrowRightMinus;

				if (!$(this).hasClass('navInside')) {
					if (winW <= rowMaxWArrows) {
						$(this).addClass('navInside');
					}
				} else {
					if (winW > rowMaxWArrows) {
						$(this).removeClass('navInside');
					}
				}
			}
		});
	}


	/**
	 * Get string with first letter lowercased
	 * @param {string} str string
	 * @returns {string}
	 */
	firstToLowerCase(str) {
		return str.substr(0, 1).toLowerCase() + str.substr(1);
	}
}

export default (new ContentSlider($body.find('.contentSlider')));